import { useContext, useEffect, useState } from "react";
import organizationService from "../Services/organization.service";
import LoaderContext from "../Context/LoaderContext/Index";

const useExpiry = () => {
  const { setLoading } = useContext(LoaderContext);
  const [isBasePlanExpired, setIsBasePlanExpired] = useState<boolean>(false);
  const checkExpiry = async () => {
    try {
      setLoading(true);
      const isExpired: boolean =
        await organizationService.checkBasePlanExpiry();
      setIsBasePlanExpired(isExpired);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error while checking plan expiry:", error);
    }
  };

  useEffect(() => {
    checkExpiry();
  }, []);

  return {
    isBasePlanExpired,
  };
};

export default useExpiry;
